var StoryLink = [];
StoryLink[0] = "https://www.meng-dong.com";
StoryLink[1] = "http://mp.weixin.qq.com/s?__biz=MzA5ODk1NDc5Mw==&mid=2650894944&idx=1&sn=05994c359d9a1c71a0df8f728d73662b&mpshare=1&scene=1&srcid=1103TJUhyUz9Gml5hmeJHvA9#rd";
StoryLink[2] = "http://mp.weixin.qq.com/s?__biz=MzA5ODk1NDc5Mw==&mid=2650894993&idx=1&sn=b11b790d0ab1d0137247db38bc7556c3&mpshare=1&scene=1&srcid=1103LpVc6sMg80uUAxCFWxKy#rd";
StoryLink[3] = "http://mp.weixin.qq.com/s?__biz=MzA5ODk1NDc5Mw==&mid=2650895050&idx=1&sn=0cfa42f8b3a87f5e65e577ef7f4953ee&mpshare=1&scene=1&srcid=1103GnsrNQUNEbYMTRhGzXFC#rd";
StoryLink[4] = "http://mp.weixin.qq.com/s?__biz=MzA5ODk1NDc5Mw==&mid=2650895179&idx=1&sn=b3bd0c9b4142959496827fd607ef12cf&chksm=8b7c680dbc0be11bef66478d3f674004a06c39f7b8337e2206cba6bfbbcabe7f9ed86b7b0e7b&mpshare=1&scene=1&srcid=1103DEcHLxHuYkGylttHbNt6#rd";

var StoryImg = [];
StoryImg[1] = "i/story_item_1.jpg";
StoryImg[2] = "i/story_item_2.jpg";
StoryImg[3] = "i/story_item_3.jpg";
StoryImg[4] = "i/story_item_4.jpg";

$(document).ready(function() {
  for (var i = 0; i < 4; i++) {
    var selector = ".content-2-item:nth-child(" + (i + 1) + ")";
    $(selector + ' .item-img-container img').attr("src", StoryImg[i + 1]);
  }
})

function gotoStoryPage(index) {
  index |= 0;
  window.open(StoryLink[index]);
}
